import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "white",
    flexDirection: "column",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "1em",
    height: "100%",
    flexFlow: "wrap",
    margin: 5,
    [theme.breakpoints.up("md")]: {
      width: "40rem",
      flexDirection: "row",
      flexFlow: "no-wrap",
    },
  },
  calendar: {
    flexDirection: "column",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    height: 380,
    [theme.breakpoints.up("md")]: {
      marginLeft: "12rem",
    },
  },
  title: {
    fontSize: 18,
    fontWeight: "bold",
    width: "20rem",
  },
  formik: {
    width: "100%",
  },
  nextButton: {
    boxShadow: "0 0 0",
    fontSize: "1.2rem",
    borderRadius: 0,
    maxWidth: "150px",
    height: "65px",
    width: "100%",
  },
  backButton: {
    boxShadow: "0 0 0",
    fontSize: "1.2rem",
    borderRadius: 0,
    maxWidth: "150px",
    height: "65px",
    width: "100%",
  },
}));

export default useStyles;
